import React, { useEffect, useState } from 'react';
import { useTheme } from '@emotion/react';
import { Slider } from '@ui-kit-ngs/slider';
import { Skeleton } from '../Skeleton';
import { mapContentstackData } from '../../mappers';
import { fetchData } from '../../data-providers';
import { ImageSizeType } from '../../consts';
export const BannersSlider = ({ dataUrl, navigate, isSkeletonVisible = true }) => {
    const { device } = useTheme();
    const imageSize = device === 'desktop' ? ImageSizeType.WIDE : ImageSizeType.SMALL;
    // TODO: ui-kit-ngs Slider don't accept empty array, needs to be a valid SliderItem element otherwise component fails
    const emptySliderItem = { Banner: React.createElement("div", null), id: '', label: '' };
    const [loaded, setLoaded] = useState(false);
    const [visible, setVisible] = useState(true);
    const [items, setItems] = useState([emptySliderItem]);
    useEffect(() => {
        const setSliderItems = async () => {
            setVisible(true);
            const data = (await fetchData(dataUrl)); // TODO: probably fetch abort controller will be needed for SPA re-renders
            if (data) {
                const mappedData = mapContentstackData({ data, imageSize, navigate, setLoaded });
                mappedData ? setItems(mappedData) : setVisible(false);
            }
            else {
                setVisible(false);
            }
        };
        setSliderItems();
    }, [dataUrl]);
    if (!visible)
        return null;
    return (React.createElement(React.Fragment, null,
        isSkeletonVisible && !loaded && React.createElement(Skeleton, { imageSize: imageSize }),
        React.createElement("div", { style: { display: `${!loaded ? 'none' : 'block'}` } },
            React.createElement(Slider, { items: items }))));
};
